var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:{
    avatar__bordered: _vm.border,
    avatar__orange: _vm.userNotHasAvatar,
  },style:(_vm.avatarSize)},[(_vm.emptyUser)?_c('img',{attrs:{"src":"/img/icons/no-avatar-grayscale.svg","alt":"no-avatar"}}):(_vm.userNotHasAvatar)?_c('div',{staticClass:"no-avatars-letters"},[_vm._v(" "+_vm._s(_vm.shortNameLetters)+" ")]):_c('img',{attrs:{"src":_vm.user.imageUrl,"alt":"avatar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }